<docs>
    This vue component is for senders wanting to place a booking from their unleashed orders
</docs>
<template>
    <modal @cancel="closeModal" :large="true">
        <div slot="title">Unleashed Sales Orders</div>
        
        <loading-alert v-if="loading" text="Loading orders"></loading-alert>
        
        <div v-else>
            <div class="modal-body table-responsive">
                <div v-if="orders.length == 0" class="alert alert-warning">No orders to show.</div>
                <table v-else class="table table-striped">
                    <tr>
                        <th>
                            Sales Order Number
                        </th>
                        <th>
                            Order Status
                        </th>
                        <th>
                            Delivery Method
                        </th>
                        <th>
                            Delivery Address
                        </th>
                        <th>
                            Order Details
                        </th>
                        <th>
                            Contains Dgs
                        </th>
                        <th>
                            Total Weight
                        </th>
                        <th>
                            Total Volume
                        </th>
                         <th>
                            Actions
                        </th>
                    </tr>
                    <tr v-for="order in orders" :key="order.OrderNumber">
                        <td>
                            {{ order.OrderNumberInteger }}<br>
                        </td>
                         <td>
                            {{ order.OrderStatus }}<br>
                        </td>
                         <td>
                            {{ order.DeliveryMethod }}<br>
                        </td>
                        <td>
                            <strong>{{ order.CustomerName }} ({{ order.CustomerCode }})</strong>, <br>
                            <span v-if="order.DeliveryStreetAddress">{{order.DeliveryStreetAddress}},</span>
                            <span v-if="order.DeliveryStreetAddress2">{{order.DeliveryStreetAddress2}},</span>
                            <span v-if="order.DeliverySuburb">{{order.DeliverySuburb}},</span>
                            <span v-if="order.DeliveryCity">{{order.DeliveryCity}},</span>
                            <span v-if="order.DeliveryRegion">{{order.DeliveryRegion}}</span><br/><br/>
                            <strong>{{order.MatchingLocationText}}</strong>
                        </td>
                        <td>
                            <ul>
                                <li v-for="line in order.SalesOrderLines" :key="line.Guid">
                                    {{ line.OrderQuantity }} x {{ line.Product.ProductCode }} ({{ line.Product.ProductDescription }})
                                </li>
                            </ul><br>
                            <strong>{{order.FreightNumber}} x {{order.FreightType}}</strong>
                        </td>
                        <td>
                            <span>{{ order.ContainsDg ? 'Yes' : 'No' }}</span><br>
                        </td>
                        <td>
                            <span>{{ order.TotalWeight }} kgs</span><br>
                        </td>
                         <td>
                            {{ order.TotalVolume }} m<sup>3</sup><br>
                        </td>
                         <td>
                            <button v-if="loadingOrderId == order.OrderNumber" class="btn btn-sm btn-success btn-block" disabled><i class="fa fa-spinner fa-spin"></i></button>
                            <button v-else @click="useOrder(order)" type="button" class="btn btn-sm btn-success btn-block">Prefill Booking Form</button>
                            <!-- <button type="button" class="btn btn-sm btn-primary btn-block" disabled>Book and Print Label</button> -->
                            <!-- <button v-if="placingBookingUpdateUnleashedDirectly" class="btn btn-sm btn-primary btn-block" disabled><i class="fa fa-spinner fa-spin"></i></button>
                            <button v-else type="button" @click="bookDirectly(order)" class="btn btn-sm btn-primary btn-block" :disabled="order.MatchingLocation === 0">Book and Print Label</button> -->
                            <button type="button" @click="bookDirectly(order)" class="btn btn-sm btn-primary btn-block" :disabled="order.MatchingLocation === 0 || order.DeliveryMethod === 'FreightHub' || order.DeliveryMethod === 'Mainfreight'">Book and Print Label</button>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="modal-footer">
                <button @click="closeModal" type="button" class="btn btn-secondary"
                        data-dismiss="modal">Close
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import moment from 'moment';
    import Modal from '../../utils/Modal_v2';
    import LoadingAlert from '../../utils/LoadingAlert';
    import { loaded } from 'vue2-google-maps';

    export default {
        name: 'unleashed-orders',
        components: {
            Modal,
            LoadingAlert
        },
        props: ['placingBookingUpdateUnleashedDirectly'],
        data() {
            return {
                loadingOrderId: null,
                loadingBookAndPrint: null,
                loading: true,
                orders: []
            }
        },

        mounted() {
            this.loadOrders();
        },

        methods: {
            closeModal() {
                this.$emit('cancelled');
            },

            loadOrders() {
                axios.get('/send-freight/unleashed/shipments')
                     .then(response => {
                         this.orders = response.data.data;
                         this.loading = false;
                     });
            },

            useOrder(order) {
                this.loadingOrderId = order.OrderNumber;

                this.$emit('choosen', order);
            },

            bookDirectly(order) {
                this.loadingBookAndPrint = order.OrderNumberInteger;

                this.$emit('directbooking', order);
            }
        }
    }
</script>